import React from 'react';
import Container from "./Container";
import PropTypes from "prop-types";


const HowTo = ({title, steps}) => {
  return (
    <div itemScope itemType="https://schema.org/HowTo">
      <Container>
        <h2 className="howto__title" itemProp="name">
          {title}
        </h2>
        <ol className="howto__items">
          {steps.map((step, index)=> {
            return (
              <li
                key={index}
                itemScope
                itemType="https://schema.org/HowToStep"
                itemProp="step"
                content={(index + 1).toString()}
                className="howto__item">
                <span className="howto__id" itemProp="id">{index + 1}</span>
                <span itemProp="text">{step}</span>
              </li>
            )
          })}
        </ol>
      </Container>
    </div>
  );
};
HowTo.propTypes = {
  title: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};
export default HowTo;
